import React from "react";

export const HeavyRainIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="40" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M21.888 62.181a1.418 1.418 0 10-2.005-2.005l-4.678 4.678a1.418 1.418 0 002.005 2.005l4.678-4.678zM31.058 62.181a1.418 1.418 0 00-2.005-2.005l-4.678 4.678a1.418 1.418 0 102.005 2.005l4.678-4.678zM40.228 62.563a1.418 1.418 0 10-2.005-2.005l-4.679 4.678a1.418 1.418 0 102.005 2.005l4.679-4.678zM49.4 62.563a1.418 1.418 0 00-2.005-2.005l-4.679 4.678a1.418 1.418 0 102.005 2.005l4.679-4.678zM58.567 62.181a1.418 1.418 0 10-2.005-2.005l-4.678 4.678a1.418 1.418 0 002.005 2.005l4.678-4.678z"
                        fill="#9ADAFF"
                    />
                    <path
                        d="M3.333 40.85c0 7.776 6.395 14.07 14.272 14.07h41.776c6.103 0 11.059-4.878 11.059-10.907 0-2.367-.767-4.622-2.165-6.484a1.418 1.418 0 00-2.268 1.702 7.931 7.931 0 011.597 4.782c0 4.453-3.676 8.072-8.222 8.072H17.605c-6.32 0-11.436-5.035-11.436-11.236 0-5.965 4.748-10.889 10.792-11.218a1.418 1.418 0 001.333-1.268c.723-6.894 6.656-12.194 13.772-12.194 5.871 0 11.04 3.623 13.015 8.951a1.418 1.418 0 002.66-.985c-2.386-6.437-8.614-10.802-15.675-10.802-8.162 0-15.045 5.808-16.43 13.578-6.971.947-12.302 6.847-12.302 13.938z"
                        fill="#717277"
                    />
                    <path
                        d="M76.666 29.455c0 3.63-2.983 6.562-6.651 6.562H53.006c-.118 0-.232-.014-.342-.041-3.308-.369-5.854-3.138-5.854-6.474 0-3.35 2.559-6.1 5.844-6.472 1.167-4.001 4.908-6.861 9.258-6.861 4.331 0 8.064 2.837 9.246 6.82 3.125.535 5.508 3.222 5.508 6.466zm-6.651 3.727c2.113 0 3.816-1.674 3.816-3.727s-1.703-3.727-3.816-3.727a1.418 1.418 0 01-1.4-1.178c-.545-3.177-3.367-5.546-6.703-5.546-3.37 0-6.212 2.416-6.718 5.635a1.418 1.418 0 01-1.502 1.194 3.923 3.923 0 00-.279-.01c-2.086 0-3.767 1.653-3.767 3.68 0 1.918 1.513 3.518 3.468 3.667.034.003.068.007.101.012h16.8z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
